module.exports = __webpack_public_path__ + "img/honey_oak_961m_detail_rsh.f2f118cd.jpg";